import React, { useState } from "react";
import axios from "axios";
import { AIOutput, ChipSelector } from "@/components/shared";
import { API } from "@/lib/api";

// ============= NEWSLETTER INTEL SECTION =============
const NewsletterIntel = () => {
  const [form, setForm] = useState({
    newsletter_text: "",
    source: "rundown-ai",
    output_type: "post-ideas",
  });
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const sources = [
    { value: "rundown-ai", label: "The Rundown AI" },
    { value: "marketing-mindset", label: "Marketing Mindset" },
    { value: "other", label: "Other" },
  ];

  const outputTypes = [
    { value: "post-ideas", label: "Post Ideas" },
    { value: "script", label: "Full Script" },
    { value: "linkedin", label: "LinkedIn Post" },
    { value: "ai-tea", label: "AI Tea Script" },
  ];

  const extractIntel = async () => {
    if (!form.newsletter_text) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/extract`, form);
      setOutput(res.data.result);
    } catch (e) {
      console.error("Error extracting:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-zinc-900">Newsletter Intel</h2>
        <p className="text-zinc-500 mt-1">Extract content ideas from any newsletter</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-4 sm:p-6 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-zinc-500 block mb-2">
              Paste Newsletter Content
            </label>
            <textarea
              value={form.newsletter_text}
              onChange={(e) => setForm({ ...form, newsletter_text: e.target.value })}
              className="textarea-field h-64"
              placeholder="Paste the newsletter email content here..."
              data-testid="newsletter-input"
            />
          </div>

          <ChipSelector label="Source" options={sources} selected={form.source} onChange={(v) => setForm({ ...form, source: v })} />
          <ChipSelector label="Output Type" options={outputTypes} selected={form.output_type} onChange={(v) => setForm({ ...form, output_type: v })} />

          <button onClick={extractIntel} disabled={!form.newsletter_text || loading} className="btn-primary w-full" data-testid="extract-intel-btn">
            {loading ? "Extracting..." : "Extract Intel"}
          </button>
        </div>

        <AIOutput content={output} loading={loading} label="Extracted Content" />
      </div>
    </div>
  );
};

export default NewsletterIntel;
